function Dot({ className }: { className: string }) {
  return (
    <span className={`inline-block h-2.5 w-2.5 rounded-full ${className}`} />
  );
}

function Card({
  label,
  value,
  dot,
  sub,
  subDot,
}: {
  label: string;
  value: number;
  dot: string;
  sub?: number;
  subDot?: string;
}) {
  return (
    <div className="rounded-xl border border-slate-100 bg-white p-5 shadow-sm">
      <div className="flex items-center gap-1.5 mb-2">
        <Dot className={dot} />
        <p className="text-xs text-slate-500">{label}</p>
      </div>
      <p className="text-3xl font-semibold text-slate-800">{value}</p>
      {sub !== undefined && subDot && (
        <div className="mt-1.5 flex items-center gap-1.5 text-xs text-slate-400">
          <Dot className={subDot} />
          <span>{sub}</span>
        </div>
      )}
    </div>
  );
}

export function ReconciliationSummaryCards({
  colorSummary,
  companyDeltaSummary,
}: {
  colorSummary: {
    red: number;
    orange: number;
    greenDark: number;
    greenLight: number;
    manual: number;
  };
  companyDeltaSummary: {
    addedCount: number;
    removedCount: number;
    pdfRawCount: number | null;
    trrRawCount: number | null;
  };
}) {
  return (
    <div className="mt-8 grid gap-4 md:grid-cols-6">
      <Card label="Conflict" value={colorSummary.red} dot="bg-red-500" />
      <Card
        label="Missing data"
        value={colorSummary.orange}
        dot="bg-orange-300"
      />
      <Card
        label="Match"
        value={colorSummary.greenDark}
        dot="bg-emerald-600"
        sub={colorSummary.greenLight}
        subDot="bg-emerald-300"
      />
      <Card
        label="Manual override"
        value={colorSummary.manual}
        dot="bg-violet-500"
      />
      <div className="rounded-xl border border-slate-100 bg-white p-5 shadow-sm">
        <p className="mb-2 text-xs text-slate-500">Companies</p>
        <p className="text-3xl font-semibold">
          <span className="text-emerald-600">
            {companyDeltaSummary.addedCount}
          </span>
          <span className="text-slate-300 mx-1 text-2xl">/</span>
          <span className="text-rose-500">
            {companyDeltaSummary.removedCount}
          </span>
        </p>
        <p className="mt-1.5 text-[11px] text-slate-400">added / removed</p>
      </div>
      <div className="rounded-xl border border-slate-100 bg-white p-5 shadow-sm">
        <p className="mb-2 text-xs text-slate-500">Portfolio companies</p>
        {companyDeltaSummary.pdfRawCount === null ? (
          <p className="text-3xl font-semibold text-slate-300">—</p>
        ) : (
          <p className="text-3xl font-semibold">
            <span className="text-rose-600">
              {companyDeltaSummary.pdfRawCount}
            </span>
            <span className="text-slate-300 mx-1 text-2xl">/</span>
            <span className="text-emerald-600">
              {companyDeltaSummary.trrRawCount ?? 0}
            </span>
          </p>
        )}
        <p className="mt-1.5 text-[11px] text-slate-400">PDF / Excel</p>
      </div>
    </div>
  );
}
